import React from "react";
import { Typography, Link } from "@material-ui/core";

// target="_blank" rel="noopener"

const Enquiries = props => {
  let languageNorthAmercia = props.region === "us" || props.region === "ca";
  return (
    <div>
      <Typography variant="h6" align="center">
        For more information on how Swivelpole™ can assist you
      </Typography>
      <Typography variant="h6" align="center">
        <Link href={"/" + props.region + "/contact"}>
          <span className="ssj-button" style={{ marginTop: "18px" }}>
            {languageNorthAmercia ? "Inquire" : "Enquire"} Now
          </span>
        </Link>
      </Typography>
    </div>
  );
};

export default Enquiries;
